// src/pages/Events.js
import React from 'react';
import './events.css'; // Import CSS for styling

const eventsData = {
  March: [
    { title: 'യൂണിയൻ ഭാരവാഹികളുടെ തിരഞ്ഞെടുപ്പ്', date: 'March 10 ', description: 'യൂണിയൻ ഭാരവാഹികളുടെ തിരഞ്ഞെടുപ്പ്' },
    { title: 'സംസ്ഥാന ക്വിസ് മത്സരം', date: 'March 25', description: 'സംസ്ഥാന ക്വിസ് മത്സരം' },
  ],
  April: [
    { title: 'യൂണിയൻ ഭാരവാഹികളുടെ തിരഞ്ഞെടുപ്പ്', date: ' ', description: 'യൂണിയൻ ഭാരവാഹികളുടെ തിരഞ്ഞെടുപ്പ്' },
    { title: 'സംസ്ഥാന ക്വിസ് മത്സരം', date: '', description: 'സംസ്ഥാന ക്വിസ് മത്സരം' },
  ],
  May: [
    { title: 'യൂണിയൻ ഭാരവാഹികളുടെ തിരഞ്ഞെടുപ്പ്', date: ' ', description: 'യൂണിയൻ ഭാരവാഹികളുടെ തിരഞ്ഞെടുപ്പ്' },
    { title: 'സംസ്ഥാന ക്വിസ് മത്സരം', date: '', description: 'സംസ്ഥാന ക്വിസ് മത്സരം' },
  ],
  June: [
    { title: 'യൂണിയൻ ഭാരവാഹികളുടെ തിരഞ്ഞെടുപ്പ്', date: ' ', description: 'യൂണിയൻ ഭാരവാഹികളുടെ തിരഞ്ഞെടുപ്പ്' },
    { title: 'സംസ്ഥാന ക്വിസ് മത്സരം', date: '', description: 'സംസ്ഥാന ക്വിസ് മത്സരം' },
  ],
  July: [
    { title: 'യൂണിയൻ ഭാരവാഹികളുടെ തിരഞ്ഞെടുപ്പ്', date: ' ', description: 'യൂണിയൻ ഭാരവാഹികളുടെ തിരഞ്ഞെടുപ്പ്' },
    { title: 'സംസ്ഥാന ക്വിസ് മത്സരം', date: ' ', description: 'സംസ്ഥാന ക്വിസ് മത്സരം' },
  ],
  August: [
    { title: 'യൂണിയൻ ഭാരവാഹികളുടെ തിരഞ്ഞെടുപ്പ്', date: ' ', description: 'യൂണിയൻ ഭാരവാഹികളുടെ തിരഞ്ഞെടുപ്പ്' },
    { title: 'സംസ്ഥാന ക്വിസ് മത്സരം', date: ' ', description: 'സംസ്ഥാന ക്വിസ് മത്സരം' },
  ],
  September: [
    { title: 'യൂണിയൻ ഭാരവാഹികളുടെ തിരഞ്ഞെടുപ്പ്', date: ' ', description: 'യൂണിയൻ ഭാരവാഹികളുടെ തിരഞ്ഞെടുപ്പ്' },
    { title: 'സംസ്ഥാന ക്വിസ് മത്സരം', date: '', description: 'സംസ്ഥാന ക്വിസ് മത്സരം' },
  ],
  October: [
    { title: 'യൂണിയൻ ഭാരവാഹികളുടെ തിരഞ്ഞെടുപ്പ്', date: ' ', description: 'യൂണിയൻ ഭാരവാഹികളുടെ തിരഞ്ഞെടുപ്പ്' },
    { title: 'സംസ്ഥാന ക്വിസ് മത്സരം', date: ' ', description: 'സംസ്ഥാന ക്വിസ് മത്സരം' },
  ],
  November: [
    { title: 'യൂണിയൻ ഭാരവാഹികളുടെ തിരഞ്ഞെടുപ്പ്', date: ' ', description: 'യൂണിയൻ ഭാരവാഹികളുടെ തിരഞ്ഞെടുപ്പ്' },
    { title: 'സംസ്ഥാന ക്വിസ് മത്സരം', date: '', description: 'സംസ്ഥാന ക്വിസ് മത്സരം' },
  ],
  December: [
    { title: 'യൂണിയൻ ഭാരവാഹികളുടെ തിരഞ്ഞെടുപ്പ്', date: ' ', description: 'യൂണിയൻ ഭാരവാഹികളുടെ തിരഞ്ഞെടുപ്പ്' },
    { title: 'സംസ്ഥാന ക്വിസ് മത്സരം', date: '', description: 'സംസ്ഥാന ക്വിസ് മത്സരം' },
  ],
  January: [
    { title: 'പ്രസംഗമത്സരം', date: 'January 15', description: 'പി.സി. അലക്സാണ്ടർ സംസ്ഥാന മത്സരം' },
    { title: 'മോഡൽ പാർലമെന്റ്', date: 'January 18', description: 'സഖ്യം ഭാരവാഹികളെ പങ്കെടുപ്പിച്ചുകൊണ്ട്' },
    { title: 'ക്വിസ് മത്സരം', date: 'January 18', description: 'ക്വിസ് മത്സരം' },
  ],
  February: [
    { title: 'യൂണിയൻ ഭാരവാഹികളുടെ തിരഞ്ഞെടുപ്പ്', date: ' ', description: 'യൂണിയൻ ഭാരവാഹികളുടെ തിരഞ്ഞെടുപ്പ്' },
    { title: 'സംസ്ഥാന ക്വിസ് മത്സരം', date: 'February 20', description: 'സംസ്ഥാന ക്വിസ് മത്സരം' },
  ],
  // Add more months and events as needed
};

function Events() {
    return (
      <div className="calendar-container">
        <h1 className="calendar-title">📅 EVENTS CALENDAR</h1>
        <div className="calendar-grid">
          {Object.entries(eventsData).map(([month, events]) => (
            <div key={month} className="calendar-month">
              <h2 className="month-title">{month}</h2>
              <ul className="month-events">
                {events.map((event, index) => (
                  <li key={index} className="calendar-event">
                    <h3 className="event-title">{event.title}</h3>
                    <div className="event-details">
                      {event.date && <p><strong>📌 {event.date}</strong></p>}
                      <p>{event.description}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    );
  }
  
  export default Events;